import { combineReducers } from 'redux'

import { STATE } from '../session/constants'
import { reducer } from '../session/reducers'
import { STATE as STATE_STORY } from '../story/constants'
import { reducer as reducersStory } from '../story/reducers'
import { STATE as STATE_CHAT } from '../messages/constants'
import { reducer as reducersChat } from '../messages/reducers'
import { STATE as STATE_SCROLL } from '../scroll/constants'
import { reducer as reducersScroll } from '../scroll/reducers'
import { STATE as STATE_CHATS_CATEGORY } from '../chatCategory/constants'
import { reducer as reducerChats } from '../chatCategory/reducers'
import { reducer as reducersAudio } from '../audio/reducers'
import { STATE as STATE_AUDIO } from '../audio/constants'

const createReducer = asyncReducers => {
  return (
    combineReducers({
      ...asyncReducers,
      [STATE]: reducer,
      [STATE_STORY]: reducersStory,
      [STATE_CHAT]: reducersChat,
      [STATE_SCROLL]: reducersScroll,
      [STATE_CHATS_CATEGORY]: reducerChats,
      [STATE_AUDIO]: reducersAudio,
    })
  )
}

export default createReducer
